// package: billingmanager
// file: billing-manager.proto

var billing_manager_pb = require("./billing-manager_pb");
var grpc = require("@improbable-eng/grpc-web").grpc;

var BillingManager = (function () {
  function BillingManager() {}
  BillingManager.serviceName = "billingmanager.BillingManager";
  return BillingManager;
}());

BillingManager.CreateSubscription = {
  methodName: "CreateSubscription",
  service: BillingManager,
  requestStream: false,
  responseStream: false,
  requestType: billing_manager_pb.CreateSubscriptionReq,
  responseType: billing_manager_pb.CreateSubscriptionReply
};

BillingManager.CancelSubscription = {
  methodName: "CancelSubscription",
  service: BillingManager,
  requestStream: false,
  responseStream: false,
  requestType: billing_manager_pb.CancelSubscriptionReq,
  responseType: billing_manager_pb.CancelSubscriptionReply
};

BillingManager.CancelSubscriptionImmediately = {
  methodName: "CancelSubscriptionImmediately",
  service: BillingManager,
  requestStream: false,
  responseStream: false,
  requestType: billing_manager_pb.CancelSubscriptionImmediatelyReq,
  responseType: billing_manager_pb.CancelSubscriptionImmediatelyReply
};

BillingManager.ModifySubscription = {
  methodName: "ModifySubscription",
  service: BillingManager,
  requestStream: false,
  responseStream: false,
  requestType: billing_manager_pb.ModifySubscriptionReq,
  responseType: billing_manager_pb.ModifySubscriptionReply
};

BillingManager.ListSubscriptions = {
  methodName: "ListSubscriptions",
  service: BillingManager,
  requestStream: false,
  responseStream: false,
  requestType: billing_manager_pb.ListSubscriptionsReq,
  responseType: billing_manager_pb.ListSubscriptionsReply
};

BillingManager.ReactivateSubscription = {
  methodName: "ReactivateSubscription",
  service: BillingManager,
  requestStream: false,
  responseStream: false,
  requestType: billing_manager_pb.ReactivateSubscriptionReq,
  responseType: billing_manager_pb.ReactivateSubscriptionReply
};

BillingManager.BillingOverview = {
  methodName: "BillingOverview",
  service: BillingManager,
  requestStream: false,
  responseStream: false,
  requestType: billing_manager_pb.BillingOverviewReq,
  responseType: billing_manager_pb.BillingOverviewReply
};

BillingManager.RenewOverDueSubscription = {
  methodName: "RenewOverDueSubscription",
  service: BillingManager,
  requestStream: false,
  responseStream: false,
  requestType: billing_manager_pb.RenewOverDueSubscriptionReq,
  responseType: billing_manager_pb.RenewOverDueSubscriptionReply
};

BillingManager.GetOverDueInfo = {
  methodName: "GetOverDueInfo",
  service: BillingManager,
  requestStream: false,
  responseStream: false,
  requestType: billing_manager_pb.GetOverDueInfoReq,
  responseType: billing_manager_pb.GetOverDueInfoReply
};

BillingManager.ListInvoices = {
  methodName: "ListInvoices",
  service: BillingManager,
  requestStream: false,
  responseStream: false,
  requestType: billing_manager_pb.ListInvoicesReq,
  responseType: billing_manager_pb.ListInvoicesReply
};

BillingManager.GetUpcomingInvoice = {
  methodName: "GetUpcomingInvoice",
  service: BillingManager,
  requestStream: false,
  responseStream: false,
  requestType: billing_manager_pb.GetUpcomingInvoiceReq,
  responseType: billing_manager_pb.GetUpcomingInvoiceReply
};

BillingManager.GetDownloadableInvoice = {
  methodName: "GetDownloadableInvoice",
  service: BillingManager,
  requestStream: false,
  responseStream: false,
  requestType: billing_manager_pb.GetDownloadableInvoiceReq,
  responseType: billing_manager_pb.GetDownloadableInvoiceReply
};

BillingManager.ListPrices = {
  methodName: "ListPrices",
  service: BillingManager,
  requestStream: false,
  responseStream: false,
  requestType: billing_manager_pb.ListPricesReq,
  responseType: billing_manager_pb.ListPricesReply
};

BillingManager.ListCards = {
  methodName: "ListCards",
  service: BillingManager,
  requestStream: false,
  responseStream: false,
  requestType: billing_manager_pb.ListCardsReq,
  responseType: billing_manager_pb.ListCardsReply
};

BillingManager.SetDefaultPaymentMethod = {
  methodName: "SetDefaultPaymentMethod",
  service: BillingManager,
  requestStream: false,
  responseStream: false,
  requestType: billing_manager_pb.SetDefaultPaymentMethodReq,
  responseType: billing_manager_pb.SetDefaultPaymentMethodReply
};

BillingManager.DeleteCard = {
  methodName: "DeleteCard",
  service: BillingManager,
  requestStream: false,
  responseStream: false,
  requestType: billing_manager_pb.DeleteCardReq,
  responseType: billing_manager_pb.DeleteCardReply
};

BillingManager.CardSetUpIntent = {
  methodName: "CardSetUpIntent",
  service: BillingManager,
  requestStream: false,
  responseStream: false,
  requestType: billing_manager_pb.CardSetUpIntentReq,
  responseType: billing_manager_pb.CardSetUpIntentReply
};

BillingManager.HasPendingCryptoPayment = {
  methodName: "HasPendingCryptoPayment",
  service: BillingManager,
  requestStream: false,
  responseStream: false,
  requestType: billing_manager_pb.HasPendingCryptoPaymentRequest,
  responseType: billing_manager_pb.HasPendingCryptoPaymentReply
};

BillingManager.CreateCryptoPayment = {
  methodName: "CreateCryptoPayment",
  service: BillingManager,
  requestStream: false,
  responseStream: false,
  requestType: billing_manager_pb.CreateCryptoPaymentRequest,
  responseType: billing_manager_pb.CreateCryptoPaymentReply
};

BillingManager.AdminGetPendingDedicatedEnvSubs = {
  methodName: "AdminGetPendingDedicatedEnvSubs",
  service: BillingManager,
  requestStream: false,
  responseStream: false,
  requestType: billing_manager_pb.AdminGetPendingDedicatedEnvSubsReq,
  responseType: billing_manager_pb.AdminGetPendingDedicatedEnvSubsReply
};

BillingManager.AdminAssignDedicatedEnv = {
  methodName: "AdminAssignDedicatedEnv",
  service: BillingManager,
  requestStream: false,
  responseStream: false,
  requestType: billing_manager_pb.AdminAssignDedicatedEnvReq,
  responseType: billing_manager_pb.AdminAssignDedicatedEnvReply
};

BillingManager.AdminListSubscriptions = {
  methodName: "AdminListSubscriptions",
  service: BillingManager,
  requestStream: false,
  responseStream: false,
  requestType: billing_manager_pb.AdminListSubscriptionsReq,
  responseType: billing_manager_pb.AdminListSubscriptionsReply
};

BillingManager.AdminBillingOverview = {
  methodName: "AdminBillingOverview",
  service: BillingManager,
  requestStream: false,
  responseStream: false,
  requestType: billing_manager_pb.AdminBillingOverviewReq,
  responseType: billing_manager_pb.AdminBillingOverviewReply
};

BillingManager.AdminListInvoices = {
  methodName: "AdminListInvoices",
  service: BillingManager,
  requestStream: false,
  responseStream: false,
  requestType: billing_manager_pb.AdminListInvoicesReq,
  responseType: billing_manager_pb.AdminListInvoicesReply
};

BillingManager.AdminGetUpcomingInvoice = {
  methodName: "AdminGetUpcomingInvoice",
  service: BillingManager,
  requestStream: false,
  responseStream: false,
  requestType: billing_manager_pb.AdminGetUpcomingInvoiceReq,
  responseType: billing_manager_pb.AdminGetUpcomingInvoiceReply
};

BillingManager.AdminGetDownloadableInvoice = {
  methodName: "AdminGetDownloadableInvoice",
  service: BillingManager,
  requestStream: false,
  responseStream: false,
  requestType: billing_manager_pb.AdminGetDownloadableInvoiceReq,
  responseType: billing_manager_pb.AdminGetDownloadableInvoiceReply
};

BillingManager.AdminListCards = {
  methodName: "AdminListCards",
  service: BillingManager,
  requestStream: false,
  responseStream: false,
  requestType: billing_manager_pb.AdminListCardsReq,
  responseType: billing_manager_pb.AdminListCardsReply
};

BillingManager.AdminSetDefaultPaymentMethod = {
  methodName: "AdminSetDefaultPaymentMethod",
  service: BillingManager,
  requestStream: false,
  responseStream: false,
  requestType: billing_manager_pb.AdminSetDefaultPaymentMethodReq,
  responseType: billing_manager_pb.AdminSetDefaultPaymentMethodReply
};

BillingManager.AdminDeleteCard = {
  methodName: "AdminDeleteCard",
  service: BillingManager,
  requestStream: false,
  responseStream: false,
  requestType: billing_manager_pb.AdminDeleteCardReq,
  responseType: billing_manager_pb.AdminDeleteCardReply
};

BillingManager.AdminListPrices = {
  methodName: "AdminListPrices",
  service: BillingManager,
  requestStream: false,
  responseStream: false,
  requestType: billing_manager_pb.AdminListPricesReq,
  responseType: billing_manager_pb.AdminListPricesReply
};

BillingManager.AdminModifySubscription = {
  methodName: "AdminModifySubscription",
  service: BillingManager,
  requestStream: false,
  responseStream: false,
  requestType: billing_manager_pb.AdminModifySubscriptionReq,
  responseType: billing_manager_pb.AdminModifySubscriptionReply
};

BillingManager.AdminCancelSubscription = {
  methodName: "AdminCancelSubscription",
  service: BillingManager,
  requestStream: false,
  responseStream: false,
  requestType: billing_manager_pb.AdminCancelSubscriptionReq,
  responseType: billing_manager_pb.AdminCancelSubscriptionReply
};

BillingManager.AdminReactivateSubscription = {
  methodName: "AdminReactivateSubscription",
  service: BillingManager,
  requestStream: false,
  responseStream: false,
  requestType: billing_manager_pb.AdminReactivateSubscriptionReq,
  responseType: billing_manager_pb.AdminReactivateSubscriptionReply
};

BillingManager.AdminRenewOverDueSubscription = {
  methodName: "AdminRenewOverDueSubscription",
  service: BillingManager,
  requestStream: false,
  responseStream: false,
  requestType: billing_manager_pb.AdminRenewOverDueSubscriptionReq,
  responseType: billing_manager_pb.AdminRenewOverDueSubscriptionReply
};

BillingManager.AdminGetOverDueInfo = {
  methodName: "AdminGetOverDueInfo",
  service: BillingManager,
  requestStream: false,
  responseStream: false,
  requestType: billing_manager_pb.AdminGetOverDueInfoReq,
  responseType: billing_manager_pb.AdminGetOverDueInfoReply
};

BillingManager.AdminCancelSubscriptionImmediately = {
  methodName: "AdminCancelSubscriptionImmediately",
  service: BillingManager,
  requestStream: false,
  responseStream: false,
  requestType: billing_manager_pb.AdminCancelSubscriptionImmediatelyReq,
  responseType: billing_manager_pb.AdminCancelSubscriptionImmediatelyReply
};

exports.BillingManager = BillingManager;

function BillingManagerClient(serviceHost, options) {
  this.serviceHost = serviceHost;
  this.options = options || {};
}

BillingManagerClient.prototype.createSubscription = function createSubscription(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(BillingManager.CreateSubscription, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

BillingManagerClient.prototype.cancelSubscription = function cancelSubscription(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(BillingManager.CancelSubscription, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

BillingManagerClient.prototype.cancelSubscriptionImmediately = function cancelSubscriptionImmediately(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(BillingManager.CancelSubscriptionImmediately, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

BillingManagerClient.prototype.modifySubscription = function modifySubscription(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(BillingManager.ModifySubscription, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

BillingManagerClient.prototype.listSubscriptions = function listSubscriptions(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(BillingManager.ListSubscriptions, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

BillingManagerClient.prototype.reactivateSubscription = function reactivateSubscription(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(BillingManager.ReactivateSubscription, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

BillingManagerClient.prototype.billingOverview = function billingOverview(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(BillingManager.BillingOverview, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

BillingManagerClient.prototype.renewOverDueSubscription = function renewOverDueSubscription(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(BillingManager.RenewOverDueSubscription, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

BillingManagerClient.prototype.getOverDueInfo = function getOverDueInfo(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(BillingManager.GetOverDueInfo, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

BillingManagerClient.prototype.listInvoices = function listInvoices(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(BillingManager.ListInvoices, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

BillingManagerClient.prototype.getUpcomingInvoice = function getUpcomingInvoice(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(BillingManager.GetUpcomingInvoice, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

BillingManagerClient.prototype.getDownloadableInvoice = function getDownloadableInvoice(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(BillingManager.GetDownloadableInvoice, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

BillingManagerClient.prototype.listPrices = function listPrices(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(BillingManager.ListPrices, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

BillingManagerClient.prototype.listCards = function listCards(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(BillingManager.ListCards, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

BillingManagerClient.prototype.setDefaultPaymentMethod = function setDefaultPaymentMethod(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(BillingManager.SetDefaultPaymentMethod, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

BillingManagerClient.prototype.deleteCard = function deleteCard(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(BillingManager.DeleteCard, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

BillingManagerClient.prototype.cardSetUpIntent = function cardSetUpIntent(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(BillingManager.CardSetUpIntent, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

BillingManagerClient.prototype.hasPendingCryptoPayment = function hasPendingCryptoPayment(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(BillingManager.HasPendingCryptoPayment, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

BillingManagerClient.prototype.createCryptoPayment = function createCryptoPayment(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(BillingManager.CreateCryptoPayment, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

BillingManagerClient.prototype.adminGetPendingDedicatedEnvSubs = function adminGetPendingDedicatedEnvSubs(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(BillingManager.AdminGetPendingDedicatedEnvSubs, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

BillingManagerClient.prototype.adminAssignDedicatedEnv = function adminAssignDedicatedEnv(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(BillingManager.AdminAssignDedicatedEnv, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

BillingManagerClient.prototype.adminListSubscriptions = function adminListSubscriptions(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(BillingManager.AdminListSubscriptions, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

BillingManagerClient.prototype.adminBillingOverview = function adminBillingOverview(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(BillingManager.AdminBillingOverview, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

BillingManagerClient.prototype.adminListInvoices = function adminListInvoices(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(BillingManager.AdminListInvoices, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

BillingManagerClient.prototype.adminGetUpcomingInvoice = function adminGetUpcomingInvoice(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(BillingManager.AdminGetUpcomingInvoice, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

BillingManagerClient.prototype.adminGetDownloadableInvoice = function adminGetDownloadableInvoice(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(BillingManager.AdminGetDownloadableInvoice, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

BillingManagerClient.prototype.adminListCards = function adminListCards(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(BillingManager.AdminListCards, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

BillingManagerClient.prototype.adminSetDefaultPaymentMethod = function adminSetDefaultPaymentMethod(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(BillingManager.AdminSetDefaultPaymentMethod, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

BillingManagerClient.prototype.adminDeleteCard = function adminDeleteCard(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(BillingManager.AdminDeleteCard, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

BillingManagerClient.prototype.adminListPrices = function adminListPrices(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(BillingManager.AdminListPrices, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

BillingManagerClient.prototype.adminModifySubscription = function adminModifySubscription(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(BillingManager.AdminModifySubscription, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

BillingManagerClient.prototype.adminCancelSubscription = function adminCancelSubscription(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(BillingManager.AdminCancelSubscription, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

BillingManagerClient.prototype.adminReactivateSubscription = function adminReactivateSubscription(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(BillingManager.AdminReactivateSubscription, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

BillingManagerClient.prototype.adminRenewOverDueSubscription = function adminRenewOverDueSubscription(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(BillingManager.AdminRenewOverDueSubscription, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

BillingManagerClient.prototype.adminGetOverDueInfo = function adminGetOverDueInfo(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(BillingManager.AdminGetOverDueInfo, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

BillingManagerClient.prototype.adminCancelSubscriptionImmediately = function adminCancelSubscriptionImmediately(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(BillingManager.AdminCancelSubscriptionImmediately, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

exports.BillingManagerClient = BillingManagerClient;

var Internal = (function () {
  function Internal() {}
  Internal.serviceName = "billingmanager.Internal";
  return Internal;
}());

Internal.IntRegisterUserToStripe = {
  methodName: "IntRegisterUserToStripe",
  service: Internal,
  requestStream: false,
  responseStream: false,
  requestType: billing_manager_pb.IntRegisterUserToStripeReq,
  responseType: billing_manager_pb.IntRegisterUserToStripeReply
};

Internal.IntUpdateUserToStripe = {
  methodName: "IntUpdateUserToStripe",
  service: Internal,
  requestStream: false,
  responseStream: false,
  requestType: billing_manager_pb.IntUpdateUserToStripeReq,
  responseType: billing_manager_pb.IntUpdateUserToStripeReply
};

Internal.IntPauseSubscriptionsMany = {
  methodName: "IntPauseSubscriptionsMany",
  service: Internal,
  requestStream: false,
  responseStream: false,
  requestType: billing_manager_pb.IntPauseSubscriptionsManyReq,
  responseType: billing_manager_pb.IntPauseSubscriptionsManyReply
};

Internal.IntResumeSubscriptionMany = {
  methodName: "IntResumeSubscriptionMany",
  service: Internal,
  requestStream: false,
  responseStream: false,
  requestType: billing_manager_pb.IntResumeSubscriptionManyReq,
  responseType: billing_manager_pb.IntResumeSubscriptionManyReply
};

Internal.IntApplyCouponToSubsMany = {
  methodName: "IntApplyCouponToSubsMany",
  service: Internal,
  requestStream: false,
  responseStream: false,
  requestType: billing_manager_pb.IntApplyCouponToSubsManyReq,
  responseType: billing_manager_pb.IntApplyCouponToSubsManyReply
};

Internal.IntUpdateSubscriptionRenewal = {
  methodName: "IntUpdateSubscriptionRenewal",
  service: Internal,
  requestStream: false,
  responseStream: false,
  requestType: billing_manager_pb.IntUpdateSubscriptionRenewalReq,
  responseType: billing_manager_pb.IntUpdateSubscriptionRenewalReply
};

exports.Internal = Internal;

function InternalClient(serviceHost, options) {
  this.serviceHost = serviceHost;
  this.options = options || {};
}

InternalClient.prototype.intRegisterUserToStripe = function intRegisterUserToStripe(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Internal.IntRegisterUserToStripe, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

InternalClient.prototype.intUpdateUserToStripe = function intUpdateUserToStripe(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Internal.IntUpdateUserToStripe, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

InternalClient.prototype.intPauseSubscriptionsMany = function intPauseSubscriptionsMany(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Internal.IntPauseSubscriptionsMany, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

InternalClient.prototype.intResumeSubscriptionMany = function intResumeSubscriptionMany(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Internal.IntResumeSubscriptionMany, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

InternalClient.prototype.intApplyCouponToSubsMany = function intApplyCouponToSubsMany(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Internal.IntApplyCouponToSubsMany, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

InternalClient.prototype.intUpdateSubscriptionRenewal = function intUpdateSubscriptionRenewal(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Internal.IntUpdateSubscriptionRenewal, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

exports.InternalClient = InternalClient;

